import { render, staticRenderFns } from "./SupplierOnboardingRegisterPage.vue?vue&type=template&id=165913d5&scoped=true&"
import script from "./SupplierOnboardingRegisterPage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOnboardingRegisterPage.vue?vue&type=style&index=0&id=165913d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165913d5",
  null
  
)

export default component.exports